import { Component } from '@angular/core';

@Component({
  selector: 'app-spice-of-europe-link',
  templateUrl: './spice-of-europe-link.component.html',
  styleUrls: ['./spice-of-europe-link.component.scss'],
})
export class SpiceOfEuropeLinkComponent {}
